import { useUser } from '@/context/userContext';
import {
  getBillingSubscriptionStatus,
  isActiveSubscriptionStatus,
  isCancelledSubscriptionStatus,
  isGraceSubscriptionStatus,
  isSuspendedSubscriptionStatus,
  isPendingCancellationSubscriptionStatus,
  getBillingSubscription,
} from '@/helpers/billingHelpers';

export const useSubscriptionStatus = () => {
  const { user, isTrialAdmin } = useUser();
  const subscriptionStatus = getBillingSubscriptionStatus(user);
  const subscription = getBillingSubscription(user);
  const isActiveSubscription = isActiveSubscriptionStatus(subscriptionStatus);
  const isGraceSubscription = isGraceSubscriptionStatus(subscriptionStatus);
  const isSuspendedSubscription = isSuspendedSubscriptionStatus(subscriptionStatus);
  const isCancelledSubscription = isCancelledSubscriptionStatus(subscriptionStatus);
  const isPendingCancellationSubscription = isPendingCancellationSubscriptionStatus(subscription);

  return {
    isTrialAdmin,
    isActiveSubscription,
    isGraceSubscription,
    isSuspendedSubscription,
    isCancelledSubscription,
    isPendingCancellationSubscription,
    isInactiveSubscription: isGraceSubscription || isSuspendedSubscription || isCancelledSubscription || isTrialAdmin,
    isViewModeSubscription: isSuspendedSubscription || isCancelledSubscription,
  };
};
